import Create from '@djforth/ajax-es6-fp/create';

const AddChange = (post_data, el) => {
  el.addEventListener('change', e => {
    post_data();
  });
};

const GetValues = (activity, facility) => () => ({
  venue_search: {
    activity_type_id: activity.value,
    facility_type_id: facility.value,
  },
});

const AddScript = data => {
  const script = document.createElement('script');
  script.innerHTML = data;
  return script;
};

const HandleError = err => {
  throw new Error(err);
};

const PostData = (url, formData) => () => {
  const post_data = Create(url);
  post_data(formData())
    .then(data => {
      document.body.appendChild(AddScript(data));
    })
    .catch(err => {
      HandleError(err);
    });
};

export default (form_id, activity_id, facility_id) => {
  const form = document.getElementById(form_id);
  const activity = document.getElementById(activity_id);
  const facility = document.getElementById(facility_id);

  if (form && activity && facility) {
    const apiUrl = form.getAttribute('action');
    const formData = GetValues(activity, facility);
    const postData = PostData(apiUrl, formData);
    [activity, facility].forEach(AddChange.bind(this, postData));
  }
};
